import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import Autocomplete from '@mui/material/Autocomplete';
import ClearIcon from '@mui/icons-material/Clear';

function InstrumentAutocomplete(props) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let mappedInstruments = props.instrumentList.map((instrument) => {
      return {
        groupCondition:
          (instrument.GroupName == '' && instrument.RegionName == '') ||
          (!instrument.GroupName && !instrument.RegionName)
            ? '- unassigned'
            : `${instrument.GroupName}, ${instrument.RegionName}`,
        ...instrument,
      };
    });
    setOptions([...mappedInstruments]);
  }, [props.instrumentList]);

  const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => `${option.groupCondition} ${option.SerialNumber}`,
  });

  return (
    <Autocomplete
      clearIcon={props.hideClearIcon ? null : <DefaultClearIcon />}
      data-qa={`qa-${props.qaActionTag}InstrumentAutocomplete`}
      disableCloseOnSelect={props.disableCloseOnSelect}
      autoHighlight
      filterOptions={filterOptions}
      options={options.sort((a, b) => -b.groupCondition.localeCompare(a.groupCondition))}
      groupBy={(option) => option.groupCondition}
      getOptionLabel={(option) => option.SerialNumber}
      getOptionSelected={(option, value) => option.SerialNumber == value.SerialNumber}
      style={{ width: '100%' }}
      value={props.currentInstrument || null}
      onChange={(event, newValue) => {
        props.onChange(newValue);
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <div data-qa={`qa-${props.qaActionTag}InstrumentDropdown`}>{option.SerialNumber}</div>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          variant="standard"
          {...params}
          label="Select instrument"
          margin="normal"
          data-qa={`qa-${props.qaActionTag}InstrumentTextField`}
        />
      )}
      isOptionEqualToValue={(option, value) => option.SerialNumber === value.SerialNumber}
    />
  );
}

const DefaultClearIcon = () => {
  return <ClearIcon fontSize="small" />;
};

export default InstrumentAutocomplete;
